import { ReturnLeadReadable, Type83fEnum } from '@crm/api'
import { Language } from '@shared/types'
import { displayDate } from '@shared/utils'
import { TFunction } from 'i18next'

export const getCustomFields = (
  customFields: ReturnLeadReadable['custom_field_values'],
  t: TFunction,
  currentLang?: Language
) => {
  return customFields
    ?.map((item) => ({
      label: item?.[
        `field_key_${currentLang?.value}` as keyof typeof item
      ] as string,
      children: item?.values
        ?.map((value) => {
          if (item.field_type === Type83fEnum.DATE) {
            return displayDate(value?.value)
          }
          if (item.field_type === Type83fEnum.BOOLEAN) {
            const boolValue =
              value?.value === 'true' ||
              String(value?.value || '').toLowerCase() === 'true'

            return boolValue ? t('buttons.yes') : t('buttons.no')
          }
          return value?.value
        })
        .join(', ')
    }))
    .filter(({ children }) => children)
}
